import { Pipe, PipeTransform } from '@angular/core'
import { TimerUtility } from '@shared/utils'

@Pipe({
  name: 'timeFormat',
})
export class TimeFormatPipe implements PipeTransform {
  transform(ms: number): string {
    return TimerUtility.formatTime(ms)
  }
}
